export default {
  slate: '#939B9E',
  white: '#ffffff',
  black: '#202020',
  blackberry: '#481033',
  green: '#25F7C3',
  paua: '#2A2354',
  palatinate: '#622461',
  razzmatazz: '#F7256B',
  byzantine: '#BA38A0',
  taupe: '#948A94',
  nightRider: '#1D0918',
  neonBlue: '#5E57FE',
  spiroDiscoBall: '#1CACF3',
  ebony: '#0F061B',
  pinkSlate: '#96829E',
  transparent: 'rgba(0, 0, 0, 0)',
};



// WEBPACK FOOTER //
// ./src/stylesheet/colors.js